<template>
    <div
        class="EventCarousel"
        :class="classObject"
    >
        <slot />

        <div class="relative">
            <flickity
                ref="flickity"
                :options="flickityOptions"
            >
                <NewsCard
                    v-for="item in products"
                    :key="item.id"
                    :item="item"
                    :tag="item.productLocations || null"
                    :isProduct="isProduct"
                />
            </flickity>
            <nav
                v-if="productCount > 3"
                class="EventCarousel__nav"
            >
                <BaseButton
                    modifier="squared"
                    tag="button"
                    align="right"
                    @click="previous"
                >
                    <BaseIcon
                        icon="arrow-left"
                        color="white"
                    />
                </BaseButton>
                <BaseButton
                    modifier="squared"
                    tag="button"
                    align="left"
                    @click="next"
                >
                    <BaseIcon
                        icon="arrow-left"
                        color="white"
                    />
                </BaseButton>
            </nav>
        </div>
    </div>
</template>

<script>
import Flickity from './BaseCarousel.vue'

export default {
    name: 'EventCarousel',
    components: {
        Flickity
    },
    props: {
        products: {
            type: Array,
            required: true
        },
        classObject: {
            type: [ Object, String ],
            default: null
        },
        limit: {
            type: Number,
            default: null
        },
        overrideIds: {
            type: Array,
            default: null
        },
        isProduct: {
            type: Boolean,
            default: false
        },
        groupCarouselCells: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            flickityOptions: {
                initialIndex: 1,
                prevNextButtons: false,
                pageDots: false,
                wrapAround: this.products && this.products.length > 3,
                imagesLoaded: true,
                autoPlay: false,
                cellAlign: 'center',
                groupCells: this.groupCarouselCells
            }
        }
    },
    computed: {
        productCount() {
            return this.products.length
        },
    },
    methods: {
        next() {
            this.$refs.flickity.next();
        },

        previous() {
            this.$refs.flickity.previous();
        }
    }
}
</script>
<style lang="scss" scoped>

    .BaseHeading {
        text-align: center;
        margin-bottom: getSpacing('medium');

        @include media-query(desk) {
            margin-bottom: getSpacing('large');
        }
    }

    .NewsCard {
        display: block;
        width: 70%;

        @include media-query(lap) {
            width: 50%;
        }

        @include media-query(desk) {
            width: 33.33333333%;
        }
    }

    .EventCarousel {
        position: relative;
        opacity: 0;
        height: 0;
        transform: translateX(-50px);
        transition: transform ease-out 0.235s;

        @include media-query(portable) {
            margin-left: - getSpacing('medium');
            margin-right: - getSpacing('medium');
        }

        @include media-query(desk) {
            padding: 0 50px;
        }

        @include media-query(desk-wide) {
            padding: 0;
        }

        &.is-visible {
            opacity: 1;
            height: 100%;
            transform: translateX(0);
        }

    }

    .EventCarousel__nav {
        display: none;

        @include media-query(desk) {
            display: flex;
            justify-content: space-between;
            position: absolute;
            top: 130px;
            left: 0;
            right: 0;

            .is-pb & {
                top: 50%;
                margin-top: -21px;
            }
        }

        @include media-query(desk-wide) {
            left: - getSpacing('large');
            right: - getSpacing('large');
        }
    }

    ::v-deep .flickity-viewport {
        @include media-query(desk) {
            margin: 0 0.01%;
        }
    }
</style>
